var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2Icon3DWedge = function SvgS2Icon3DWedge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.724 1.542a.749.749 0 0 0-.626-.152l-14.5 3A.75.75 0 0 0 2 5.124v9.126c0 .284.16.543.414.67l7.25 3.637a.746.746 0 0 0 .871-.145l7.25-7.387A.75.75 0 0 0 18 10.5V2.124a.751.751 0 0 0-.276-.582ZM9.873 7.693 5.076 5.408l9.587-1.983-4.79 4.268ZM3.5 6.318l5.75 2.74v7.614L3.5 13.787V6.318Zm7.25 9.734V8.921l5.75-5.124v6.396l-5.75 5.86Z"
  })));
};
export default SvgS2Icon3DWedge;